import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { requesterService } from "../../services/request.service";

export const listRequesterOnline = createAsyncThunk(
  "requesterManage/listRequesterOnline",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await requesterService.listRequesterOnline();

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const listRequesterOffline = createAsyncThunk(
  "requesterManage/listRequesterOffline",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await requesterService.listRequesterOffline();

      return _.get(response, "data", []);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const countRequesterOnline = createAsyncThunk(
  "requesterManage/countRequesterOnline",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await requesterService.countRequesterOnline();

      return _.get(response, "data", 0);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addRequester = createAsyncThunk(
  "requesterManage/addRequester",
  async (data, { rejectWithValue }) => {
    try {
      const response = await requesterService.addRequester(data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editRequester = createAsyncThunk(
  "requesterManage/editRequester",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await requesterService.editRequester(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editRequesterNotUpdate = createAsyncThunk(
  "requesterManage/editRequesterNotUpdate",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await requesterService.editRequester(id, data);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const removeRequester = createAsyncThunk(
  "requesterManage/removeRequester",
  async (id, { rejectWithValue }) => {
    try {
      const response = await requesterService.removeRequester(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readRequester = createAsyncThunk(
  "requesterManage/readRequester",
  async (id, { rejectWithValue }) => {
    try {
      const response = await requesterService.readRequester(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const readRequesterSession = createAsyncThunk(
  "requesterManage/readRequesterSession",
  async (id, { rejectWithValue }) => {
    try {
      const response = await requesterService.readRequester(id);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
